module.exports = __webpack_public_path__ + "sgby/img/zhouyu-s.65c9e03.png";